export default __webpack_public_path__ + "static/media/add_camera.fa715257.svg";